import React, { FunctionComponent, useReducer } from 'react'
import NavigationReducer, { NavigationActionType } from '@reducers/NavigationReducer'
import { initialNavigationContext, NavigationContext } from '@context/NavigationContext'
import MenuBar from './MenuBar'
import './WithMenu.scss'

function WithMenu<P extends {}>(WrappedComponent: FunctionComponent<P>): FunctionComponent<P> {
  const ComponentWithMenu: FunctionComponent<P> = (props) => {
    const [state, dispatch] = useReducer(NavigationReducer, initialNavigationContext)

    const setPrevHandler = (handler: () => void): void => {
      dispatch({ type: NavigationActionType.SetPrevHandler, payload: handler })
    }

    const setNextHandler = (handler: () => void): void => {
      dispatch({ type: NavigationActionType.SetNextHandler, payload: handler })
    }

    const setResetHandler = (handler: () => void): void => {
      dispatch({ type: NavigationActionType.SetResetHandler, payload: handler })
    }

    const setShareHandler = (handler: () => void): void => {
      dispatch({ type: NavigationActionType.SetShareHandler, payload: handler })
    }
    const enableShare = (): void => {
      dispatch({ type: NavigationActionType.EnableShareNavigation })
    }
    const disableShare = (): void => {
      dispatch({ type: NavigationActionType.DisableShareNavigation })
    }

    return (
      <NavigationContext.Provider
        value={{
          ...state,
          setPrevHandler,
          setNextHandler,
          setResetHandler,
          enableShare,
          disableShare,
          setShareHandler,
        }}>
        <div className="Menu">
          <div className="content">
            <WrappedComponent {...props} />
          </div>
          <MenuBar />
        </div>
      </NavigationContext.Provider>
    )
  }

  return ComponentWithMenu
}

export default WithMenu
